import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { config } from "../_helpers";
import PropTypes from "prop-types";
// import { userActions } from '../_actions';

class ResourceType extends React.Component {
  constructor(props) {
    super(props);
    this.choosePosition = this.choosePosition.bind(this);
  }

  choosePosition(type) {
    this.props.choosePosition(type);
  }

  render() {
    return (
      <div className="resource_type">
        <div className="login_header">
          <Link to={"/login"}>
            <img src={`${config.assetUrl}${config.assetBrandName}_logo.png`} alt={config.assetBrandName || "Firestorm"} />
          </Link>
          <p>Workforce Management <span style={{ color: '#8A8A8A', fontStyle: 'italic', fontFamily: 'Georgia, serif' }}>Powered by</span> EMBERA</p>
        </div>

        <div className="top_head">
          <Link to={"/login"} className="back">
            Back to Login Page
          </Link>
          <span className="title">Step 1 - Choose Resource Type</span>
        </div>

        <div className="signup-contentarea">
          <div id="choosePositionWrapA0" className="position-select">
            <button
              className="disabled"
              onClick={this.choosePosition.bind(this, "FireFighter")}
              disabled
            >
              <span className="pos-sel">Firefighter Resource</span>
            </button>
            <button
              className="disabled"
              onClick={this.choosePosition.bind(this, "AdminStaff")}
              disabled
            >
              <span className="pos-sel">Admin Staff Resource</span>
            </button>
            {/* <button onClick={this.props.toInformation}>
                            <span className="pos-sel" >GISS Technician</span>
                        </button> */}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { registering } = state.registration;
  return {
    registering,
  };
}

const connectedRegisterPage = connect(mapStateToProps)(ResourceType);
export { connectedRegisterPage as ResourceType };

ResourceType.propTypes = {
  choosePosition: PropTypes.func.isRequired,
};
